export enum OCardCarouselComboCardType {
  Standard = 'standard',
  MiniIcon = 'mini-icon',
}

export interface OCardCarouselComboMContentHeaderMTextBlockSimple {
  alignment?: string;
  aEyebrow?: {
    eyebrowText?: string;
  };
  aHeader?: {
    size?: string;
    text?: string;
    headerTag?: string;
  };
  aBody?: {
    bodyText?: string;
    size?: string;
    color?: string;
  };
}

export interface OCardCarouselComboMContentHeaderMButton {
  buttonText?: string;
  buttonType?: string;
  size?: string;
  ctaLink?: string;
  openInANewTab?: string;
  externalLink?: string;
  icon?: string;
  aIcon?: {
    size?: string;
    icon?: string;
  };
}

export interface OCardCarouselComboMContentHeader {
  alignment?: string;
  cta?: string;
  secondaryCta?: string;
  mTextBlockSimple?: OCardCarouselComboMContentHeaderMTextBlockSimple;
  mButton?: OCardCarouselComboMContentHeaderMButton;
  mButton2?: OCardCarouselComboMContentHeaderMButton;
}

export interface OCardCarouselComboMCarouselControlsALabel {
  size?: string;
  text?: string;
}

export interface OCardCarouselComboMCarouselControls {
  type?: string;
  imageOverlay?: string;
  aLabel?: OCardCarouselComboMCarouselControlsALabel;
}

export interface OCardCarouselComboTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  faicUrl?: string;
  additionalTrackingVariables?: string;
}

export interface OCardCarouselComboCqItems {
  ':itemsOrder'?: string[];
  ':items'?: Record<string, Record<string, unknown>>;
  [key: string]: unknown;
}

export interface OCardCarouselComboProps {
  cardType?: string;
  peeking?: boolean;
  mContentHeader?: OCardCarouselComboMContentHeader;
  mCarouselControls?: OCardCarouselComboMCarouselControls;
  pagePath?: string;
  itemPath?: string;
  cqPath?: string;
  isAuthorMode?: boolean;
  cqItems?: OCardCarouselComboCqItems;
  ':items'?: OCardCarouselComboCqItems;
  ':itemsOrder'?: string[];
  aemReactComponentMapping?: Record<string, React.FC<Record<string, unknown>>>;
  className?: string;
  trackingProperties?: OCardCarouselComboTrackingProperties;
}
